(() => {
  class ProductPurchase {
    constructor(section, options = {}) {
      this.section = section;
      this.variants = options.variants || null;
      this.addButton = section.querySelector('[data-add-to-cart]');
      this.productForm = section.querySelector('.main-product__form');
      this.quantityInput = section.querySelector('[data-quantity-input]');
      this.minusButton = section.querySelector('[data-quantity-minus]');
      this.plusButton = section.querySelector('[data-quantity-plus]');

      this.addButtonResetTimer = null;
      this.addButtonObserver = null;

      this.handleMinusClick = this.decreaseQuantity.bind(this);
      this.handlePlusClick = this.increaseQuantity.bind(this);
      this.handleFormSubmit = this.handleProductSubmit.bind(this);
      this.handleCartUpdate = this.resetAddButtonState.bind(this);

      this.bindEvents();
      this.observeAddButton();
    }

    bindEvents() {
      this.minusButton?.addEventListener('click', this.handleMinusClick);
      this.plusButton?.addEventListener('click', this.handlePlusClick);
      this.productForm?.addEventListener('submit', this.handleFormSubmit);

      document.addEventListener('cart:updated', this.handleCartUpdate);
      document.addEventListener('cart:refresh', this.handleCartUpdate);
      document.addEventListener('cart-drawer:open', this.handleCartUpdate);
    }

    decreaseQuantity() {
      if (!this.quantityInput) return;

      const currentQuantity = Number(this.quantityInput.value || 1);
      this.quantityInput.value = Math.max(1, currentQuantity - 1);
      this.dispatchQuantityChange();
    }

    increaseQuantity() {
      if (!this.quantityInput) return;

      const currentQuantity = Number(this.quantityInput.value || 1);
      this.quantityInput.value = currentQuantity + 1;
      this.dispatchQuantityChange();
    }

    dispatchQuantityChange() {
      this.quantityInput?.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getAddButtonLabel() {
      return (
        this.variants?.getAddButtonLabel() ||
        (this.addButton?.disabled ? 'Sold out' : 'Add to cart')
      );
    }

    resetAddButtonState() {
      if (!this.addButton) return;

      window.clearTimeout(this.addButtonResetTimer);
      this.addButton.classList.remove('is-loading');

      if (!this.addButton.disabled) {
        this.addButton.textContent = this.getAddButtonLabel();
      }
    }

    observeAddButton() {
      if (!this.addButton) return;

      this.addButtonObserver = new MutationObserver(() => {
        const buttonText = this.addButton.textContent.trim().toLowerCase();
        const isAdding =
          buttonText === 'adding' ||
          buttonText === 'adding...' ||
          buttonText === 'adding…';

        if (!isAdding) return;

        this.addButton.classList.add('is-loading');
        window.clearTimeout(this.addButtonResetTimer);
        this.addButtonResetTimer = window.setTimeout(
          () => this.resetAddButtonState(),
          1800
        );
      });

      this.addButtonObserver.observe(this.addButton, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    handleProductSubmit() {
      if (!this.addButton || this.addButton.disabled) return;

      window.clearTimeout(this.addButtonResetTimer);
      this.addButton.classList.add('is-loading');
      this.addButtonResetTimer = window.setTimeout(
        () => this.resetAddButtonState(),
        2200
      );
    }

    destroy() {
      window.clearTimeout(this.addButtonResetTimer);
      this.addButtonObserver?.disconnect();

      this.minusButton?.removeEventListener('click', this.handleMinusClick);
      this.plusButton?.removeEventListener('click', this.handlePlusClick);
      this.productForm?.removeEventListener('submit', this.handleFormSubmit);

      document.removeEventListener('cart:updated', this.handleCartUpdate);
      document.removeEventListener('cart:refresh', this.handleCartUpdate);
      document.removeEventListener('cart-drawer:open', this.handleCartUpdate);
    }
  }

  window.ProductPurchase = {
    create(section, options = {}) {
      if (!section) return null;
      return new ProductPurchase(section, options);
    },
  };
})();
